import { Field, JsonParseError, JsonParseErrorCode } from "sparkson";

export class Skin {
  constructor(@Field("c", true) public color?: string) {
    if (color && !/^#[0-9a-f]{6}$/i.test(color)) {
      throw new JsonParseError("Color has to match CSS hex format" , JsonParseErrorCode.VALIDATION_FAILED);
    }
  }
}